export type UrlOrgAccess =
  | { kind: "allowed" }
  | { kind: "wrongCase"; login: string }
  | { kind: "missing" };

/**
 * Whether the user can open the org named in the URL. GitHub logins are
 * case-insensitive but the backend matches them exactly, so a case-only
 * mismatch resolves to the canonical login, e.g. `UseBlacksmith` →
 * `useblacksmith`.
 */
export function resolveUrlOrgAccess(
  urlOrg: string,
  logins: readonly string[],
  isSuperuser: boolean,
): UrlOrgAccess {
  if (isSuperuser || logins.includes(urlOrg)) return { kind: "allowed" };
  const lowered = urlOrg.toLowerCase();
  const login = logins.find((candidate) => candidate.toLowerCase() === lowered);
  return login ? { kind: "wrongCase", login } : { kind: "missing" };
}

/** `/UseBlacksmith/runs?x=1` → `/useblacksmith/runs?x=1` */
export function replaceOrgSegment(
  asPath: string,
  from: string,
  to: string,
): string {
  const [path, ...rest] = asPath.split(/(?=[?#])/);
  const segments = path.split("/");
  const index = segments.indexOf(from);
  if (index === -1) return asPath;
  segments[index] = to;
  return [segments.join("/"), ...rest].join("");
}
